const state = {
    goods_list:"",                                     //商品的列表数组
    goods_details:"",                                  //此件商品的详情
};

const mutations = {
    set_goods_list(state,val){
        state.goods_list = val;
    },
    set_goods_details(state,val){
        state.goods_details = val;
    }
};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}